import * as React from 'react';

const Drop = ({ ...props }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M7.5 11.3333L3.60289 6.83334L11.3971 6.83334L7.5 11.3333Z"
            fill="currentColor"
        />
    </svg>
);

export default Drop;
